import * as Blockly from 'blockly/core';
import { expr } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

export function register(gen: any): void {
    gen.forBlock['logical_not'] = function (block: Blockly.Block): [string, number] {
        const a = gen.valueToCode(block, 'A', 0) || 'false';
        return expr(`!${a}`);
    };
}
